export function buildOwnedColorCounts(
  nodes: ReadonlyArray<
    | { color?: string | null; customerOrderInfo: { summary: { purchaseCount: number } } }
    | null
    | undefined
  >
): Record<string, number> {
  return nodes.reduce<Record<string, number>>((acc, node) => {
    const colorId = node?.color
    if (!colorId) return acc
    acc[colorId] = (acc[colorId] ?? 0) + node.customerOrderInfo.summary.purchaseCount
    return acc
  }, {})
}

/**
 * Derives the "purchased" badge text for a given color, shared between the PDP
 * purchase badge and the reorders section tiles.
 * `ownedColorCounts` must be scoped to a single product (keyed by color id),
 * so that the "another color" fallback only considers colors of that product.
 */
export function derivePurchasedBadgeText(
  ownedColorCounts: Record<string, number> | undefined,
  colorKey: string,
  strings: { purchasedOnce: string; purchasedXTimes: string; purchasedInAnotherColor: string }
): string | null {
  if (!ownedColorCounts) return null
  const thisColorCount = colorKey ? ownedColorCounts[colorKey] : undefined
  if (thisColorCount) {
    return thisColorCount === 1
      ? strings.purchasedOnce
      : strings.purchasedXTimes.replace('{{count}}', String(thisColorCount))
  }
  if (Object.keys(ownedColorCounts).length > 0) {
    return strings.purchasedInAnotherColor
  }
  return null
}
